import React, { useState, useEffect } from "react";
import "../css/home.css";
import backgroundVideo from "../assets/Videos/blue & peach 00.1.mp4";
import backgroundVideo2 from "../assets/Videos/homevideo-2.mp4";
import LetterDrop from "./LetterDrop";
import { Container, Row, Col } from "react-bootstrap";
import SimpleCarousel from "./SimpleCarousel";
import ButtonCardDisplay from "./ButtonCardDisplay";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Lottie from "lottie-react";
import mixingConcrete from "../Lottiefiles/ready mix concrete.json";
import crystalSand from "../Lottiefiles/Crystal Sand New 9.json";
import Aggregates from "../Lottiefiles/aggregates truck Home Page New 7.json";
import Spiral from "../assets/Images/spiral.png";
import Arrow from "../assets/Images/arrow.png";
import Clients from "./Clients";
import HomeBanner1Fallback from "../assets/Images/endula gradient page-02.jpg";
import HomeBanner2Fallback from "../assets/Images/HomeBannerFrame.jpg";
export default function HomePage() {
  const [hoveredIndex, setHoveredIndex] = useState(null);
  const [cursorPosition, setCursorPosition] = useState({ x: 0, y: 0 });
  const [isCarouselHovered, setIsCarouselHovered] = useState(false);
  useEffect(() => {
    const handleMouseMove = (e) => {
      setCursorPosition({ x: e.clientX, y: e.clientY });
    };

    document.addEventListener("mousemove", handleMouseMove);
    return () => {
      document.removeEventListener("mousemove", handleMouseMove);
    };
  }, []);

  const handleMenuItemHover = (index) => {
    setHoveredIndex(index);
  };
  const testimonials = [
    {
      text: "Endula Infra has been an exceptional supplier, ensuring the highest quality materials with unmatched reliability. Their commitment to precision and on-time delivery has been a game-changer for our projects at Aparna Enterprises Limited.",
      name: "MURARI",
      title: "Aparna Enterprises Limited",
    },
    {
      text: "Working with Endula Infra has significantly improved our supply chain efficiency. Their superior aggregates and professionalism set a high standard in the industry, making them an invaluable partner for Nuvoco Vistas Corporation Ltd.",
      name: "SYED IBRHIM",
      title: "Nuvoco Vistas Corporation Ltd.",
    },
    {
      text: "Endula Infra consistently delivers high-quality materials with exceptional reliability. Their commitment to customer satisfaction makes them our go-to supplier at Shapoorji Pallonji & Co. Pvt. Ltd.",
      name: "SARAT",
      title: "Shapoorji Pallonji and Company Private Limited",
    },
    {
      text: "The seamless experience of working with Endula Infra has been invaluable to our projects. Their commitment to innovation and excellence ensures that we always receive premium-quality aggregates for My Home Constructions Pvt. Ltd.",
      name: "SHIVA SATYANARYANA",
      title: "My Home Constructions Pvt. Ltd",
    },
    {
      text: "With Endula Infra, we have found a supplier that prioritizes both quality and efficiency. Their reliability and expertise in providing top-grade aggregates have greatly enhanced our project outcomes at NCL Industries Limited.",
      name: "SRINIVAS",
      title: "NCL Industries Limited",
    },
    {
      text: "Endula Infra’s professionalism and attention to detail are truly commendable. Their high-quality materials and timely deliveries have played a key role in the successful execution of our projects at Raja Pushpa Properties Private Limited.",
      name: "SRIDHARAN",
      title: "Raja Pushpa Properties Private Limited",
    },
    {
      text: "Finding a supplier that delivers both quality and consistency is rare, but Endula Infra has done exactly that. Their exceptional service has been a cornerstone in the success of our projects at Om Sree Builders & Developers.",
      name: "JAGDISH",
      title: "Om Sree Builders & Developers",
    },
    {
      text: "Endula Infra’s top-tier materials and strategic supply chain management have optimized our project workflow. Their dedication to delivering excellence makes them an irreplaceable partner for HELLA INFRA MARKET LIMITED.",
      name: "ANIL KUMAR",
      title: "HELLA INFRA MARKET LIMITED",
    },
    {
      text: "Endula Infra’s unwavering commitment to quality and service has greatly contributed to the efficiency of our RMC production. Their seamless logistics and premium aggregates have made a significant impact at QBond RMC Private Limited.",
      name: "UTHARAPATHY",
      title: "QBond RMC Private Limited",
    },
    {
      text: "Endula Infra stands out with their unmatched professionalism and product excellence. Their reliable supply of aggregates has enabled us to execute projects with greater precision at B. Rama Rao & Co.",
      name: "RAMA RAO",
      title: "B. Rama Rao & Co",
    },
    {
      text: "Endula Infra’s dedication to delivering high-quality materials on time has set them apart from the rest. Their expertise in supply chain logistics has been instrumental in the success of our projects at A Suryakanth & Co.",
      name: "SURYAKANTH",
      title: "A Suryakanth & Co",
    },
    {
      text: "Endula Infra is a trusted partner for large-scale infrastructure projects, consistently delivering premium aggregates. Their reliability has made a significant impact at Megha Engineering & Infrastructures Limited.",
      name: "HARSHA",
      title: "Megha Engineering & Infrastructures Limited",
    },
  ];

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 2,
    slidesToScroll: 1,
    autoplay: false,
    arrows: false,
    responsive: [
      {
        breakpoint: 1080,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };
  return (
    <div className="HomePage">
      {!isCarouselHovered && (
        <>
          <div
            className={`cursor ${hoveredIndex !== null ? "big" : ""}`}
            style={{ left: cursorPosition.x, top: cursorPosition.y }}
          ></div>
          <div
            className={`cursor cursor-outline ${
              hoveredIndex !== null ? "big" : ""
            }`}
            style={{ left: cursorPosition.x, top: cursorPosition.y }}
          ></div>
        </>
      )}
      <div className="double-sections">
        <div className="heading-wrap">
          <div
            className="content"
            onMouseEnter={() => handleMenuItemHover(0)}
            onMouseLeave={() => handleMenuItemHover(null)}
          >
            <LetterDrop text1="The Future of" text2="Sand is here" />
          </div>
        </div>
        <section className="section hero">
          <div className="background-noise-new"></div>
          <div className="video-wrap">
            <div className="gradient-video w-background-video w-background-video-atom">
              <video
                id="video-1"
                autoPlay
                loop
                muted
                playsInline
                poster={HomeBanner1Fallback}
              >
                <source src={backgroundVideo} />
                <source src={backgroundVideo} />
                <img src={HomeBanner1Fallback} alt="About Banner Fallback" />
              </video>
            </div>
          </div>
        </section>
        <div className="section-wrap video2">
          <div className="section video">
            <div className="background-noise-new"></div>
            <div className="video-univ-wrap">
              <div className="video-univ w-background-video w-background-video-atom">
                <video
                  id="video-2"
                  autoPlay
                  loop
                  muted
                  playsInline
                  poster={HomeBanner2Fallback}
                >
                  <source src={backgroundVideo2} />
                  <source src={backgroundVideo2} />
                  <img src={HomeBanner2Fallback} alt="About Banner Fallback" />
                </video>
              </div>
            </div>
            <div className="section-anim-trigger"></div>
          </div>
        </div>
      </div>
      <section className="section-spacer video"></section>
      <div className="section-wrap studying">
        <div className="section studying">
          <Container fluid>
            <div className="section-cont studying">
              <h2
                onMouseEnter={() => handleMenuItemHover(0)}
                onMouseLeave={() => handleMenuItemHover(null)}
                className="h3-heading studing"
              >
                Why Choose Us
              </h2>
              <div className="section-descr studying forSameFonts">
                Endula Infra has decades of experience in the infrastructural
                industry. Endula Infra is specialized in Aggregates and RMC
                services that are well-coordinated according to the client’s
                need, no matter how big or small they are.
              </div>
            </div>
            <div className="studying-points-grid">
              <div className="studying-point ">
                <div className="icon-cont icon-1  ">
                  <Lottie
                    animationData={mixingConcrete}
                    className="lg:mt-[-60px] md:mt-[-78px]"
                    loop={true}
                    onMouseEnter={() => handleMenuItemHover(0)}
                    onMouseLeave={() => handleMenuItemHover(null)}
                  />
                </div>
                <div
                  className="studying-point-name mt-5 AnimationTitle"
                  onMouseEnter={() => handleMenuItemHover(0)}
                  onMouseLeave={() => handleMenuItemHover(null)}
                >
                  Ready Mix Concrete
                </div>
                <div className="studying-point-text forSameFonts">
                  RMC is a concrete manufactured in a batch plant for supplying
                  to sites in freshly mixed or unhardened state, to be mixed
                  with water and compacted to form concrete. It is used
                  extensively in construction industry as it has many advantages
                  over on-site method of concrete production.
                </div>
                <div className="arrow-black-hor-left">
                  <img
                    src={Arrow}
                    alt="Arrow Left"
                    className="arrow-black-end-left"
                  />
                </div>
                <div className="arrow-black-vert-up">
                  <img
                    src={Arrow}
                    alt="Arrow Up"
                    className="arrow-black-end-up"
                  />
                </div>
              </div>
              <div className="studying-point right ">
                <div className="icon-cont icon-2">
                  <Lottie
                    animationData={crystalSand}
                    className="mt-[5.5rem] sm:mt-7 md:mt-0"
                    loop={true}
                    onMouseEnter={() => handleMenuItemHover(0)}
                    onMouseLeave={() => handleMenuItemHover(null)}
                  />
                </div>
                <div
                  className="studying-point-name mt-5 AnimationTitle"
                  onMouseEnter={() => handleMenuItemHover(0)}
                  onMouseLeave={() => handleMenuItemHover(null)}
                >
                  Crystal Sand
                </div>
                <div className="studying-point-text forSameFonts">
                  Until now river sand was the only kind of sand used for
                  construction activities, because it was very economical and
                  abundantly available. But these days, it's very difficult to
                  get good qualitied sand at short distances for developing
                  cities, due to over-utilization of resources. Therefore, we
                  came up with environmentally-safe yet economical alternative
                  of river sand - Crystal Sand.
                </div>
                <div className="arrow-black-hor-right">
                  <img
                    src={Arrow}
                    alt="Arrow Right"
                    className="arrow-black-end-right"
                  />
                </div>
              </div>
              <div className="studying-point bottom ">
                <div className="icon-cont icon-3 ">
                  <Lottie
                    animationData={Aggregates}
                    className="lg:mt-[-20px] md:mt-[-30px] md:mb-3 md:pb-5"
                    loop={true}
                    onMouseEnter={() => handleMenuItemHover(0)}
                    onMouseLeave={() => handleMenuItemHover(null)}
                  />
                </div>
                <div
                  className="studying-point-name  md:mt-8 mt-5 AnimationTitle"
                  id="specialIdIcon"
                  onMouseEnter={() => handleMenuItemHover(0)}
                  onMouseLeave={() => handleMenuItemHover(null)}
                >
                  Aggregates
                </div>
                <div className="studying-point-text forSameFonts">
                  Aggregates are the materials used in construction and Civil
                  engineering. They include sand, gravel, crushed stone, and
                  recycled concrete.
                </div>
                <div className="arrow-black-vert-down">
                  <img
                    src={Arrow}
                    alt="Arrow Down"
                    className="arrow-black-end-down"
                  />
                </div>
              </div>
            </div>
          </Container>
        </div>
        <div className="section-anim-trigger"></div>
      </div>
      <section className="section-spacer studying"></section>
      <section className="section-wrap faculties">
        <div className="section faculties">
          <div className="section-cont faculty">
            <h2
              className="h2-heading facullty md:mt-[-30px] md:text-[6rem]"
              onMouseEnter={() => handleMenuItemHover(0)}
              onMouseLeave={() => handleMenuItemHover(null)}
            >
              About
            </h2>
            <div className="section-descr faculty forSameFonts">
              Endula Infra is a Stone Crushing Industry based in Hyderabad and
              has been in existence for more than three decades placing the
              company as an industry legend in Stone crushing.
            </div>
          </div>
          <Row
            className="carousel-container"
            onMouseEnter={() => setIsCarouselHovered(true)}
            onMouseLeave={() => setIsCarouselHovered(false)}
          >
            <SimpleCarousel />
          </Row>
          <ButtonCardDisplay handleMenuItemHover={handleMenuItemHover} />
          <div className="design">
            <img src={Spiral} alt="Spiral" />
          </div>
          <div className="section-anim-trigger news"></div>
        </div>
      </section>
      <section className="section-spacer faculty"></section>
      <Clients handleMenuItemHover={handleMenuItemHover} />
      <section className="section-wrap news testmonial">
        <div className="section news">
          <div className="section-cont news">
            <Container fluid className="testimonial-area forSameFonts">
              <div>
                <h2
                  onMouseEnter={() => handleMenuItemHover(0)}
                  onMouseLeave={() => handleMenuItemHover(null)}
                  className=" news text-[3.5rem] md:text-[6rem] lg:text-[6rem] lg:mt-[-72px] xl:mb-10  text-center"
                  id="TestiMonial"
                >
                  Testimonials
                </h2>
              </div>
              <div className="test-box">
                <Container fluid className="testimonial-content" id="Gutter">
                  <Slider {...settings}>
                    {testimonials.map((testimonial, index) => (
                      <div key={index}>
                        <Row className="justify-content-center">
                          <Col className="px-2 mt-5 mb-5">
                            <div className="single-testimonial">
                              <div className="round-1 round"></div>
                              <div className="round-2 round"></div>
                              <p
                                className="md:text-[18px] 2xl:text-[22px] text-[16px] py-14 md:px-5 px-2 forSameFonts"
                                id="TestParagraph"
                              >
                                {testimonial.text}
                              </p>
                              <div className="client-info">
                                <div className="client-details">
                                  <h6>{testimonial.name}</h6>
                                  <span>{testimonial.title}</span>
                                </div>
                              </div>
                            </div>
                          </Col>
                        </Row>
                      </div>
                    ))}
                  </Slider>
                </Container>
              </div>
            </Container>
            <div className="section-anim-trigger footer"></div>
          </div>
        </div>
      </section>
      <section className="section-spacer news"></section>
    </div>
  );
}
